export default __webpack_public_path__ + "static/media/Help_pls_adm.d4d1c1eb.pdf";